export default __webpack_public_path__ + "static/media/avatar_bg_gaara.b94512fe.png";